import React from 'react';
import { Link } from 'react-router';
import { motion } from 'framer-motion';
import { HomeIcon, MagnifyingGlassIcon, ArrowUturnLeftIcon } from '@heroicons/react/24/outline';

const NotFound = () => {
  return (
    <div className='flex flex-1 items-center justify-center px-6 py-0 min-h-[60vh]'>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className='max-w-lg w-full text-center'
      >
        <motion.div
          initial={{ scale: 0.5, rotate: -10 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ type: 'spring', stiffness: 200, delay: 0.1 }}
          className='mx-auto mb-8'
        >
          <div className='inline-flex'>
            <div className='w-32 h-32 rounded-2xl bg-gradient-to-br from-primary-light to-primary/30 flex items-center justify-center shadow-lg'>
              <MagnifyingGlassIcon className='w-16 h-16 text-primary' />
            </div>
          </div>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className='text-7xl font-extrabold text-primary tracking-tight'
        >
          404
        </motion.h1>

        <motion.h2
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className='mt-2 text-2xl font-bold text-gray-800'
        >
          Halaman Tidak Ditemukan
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className='mt-4 text-gray-500 leading-relaxed'
        >
          Maaf, halaman yang Anda cari tidak dapat ditemukan. Mungkin alamatnya salah, atau halaman
          sudah dipindahkan.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className='mt-8 flex flex-col sm:flex-row gap-3 justify-center'
        >
          <Link
            to='/dashboard'
            className='inline-flex items-center justify-center gap-2 rounded-lg bg-primary px-5 py-2.5 text-sm font-semibold text-white shadow-md shadow-primary/20 hover:bg-primary-dark transition-colors'
          >
            <HomeIcon className='h-4 w-4' />
            Ke Dashboard
          </Link>
          <button
            onClick={() => window.history.back()}
            className='inline-flex items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white px-5 py-2.5 text-sm font-semibold text-gray-700 table-row-hover transition-colors'
          >
            <ArrowUturnLeftIcon className='h-4 w-4' />
            Halaman Sebelumnya
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className='mt-10 p-4 bg-amber-50 rounded-xl border border-amber-100'
        >
          <p className='text-sm text-amber-800'>
            <strong>Butuh bantuan?</strong> Hubungi tim support Pulsalink jika Anda merasa ini
            adalah kesalahan sistem.
          </p>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default NotFound;
